import React from "react";
import Preloader from "../helper/Preloader";

import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import Account from "../components/Account";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { Helmet } from "react-helmet-async";

const AccountPage = () => {
  return (
    <>
      <Helmet>
        <title>My Account | Awaneez</title>
      </Helmet>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Account */}
      <Account />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default AccountPage;
